const ROLE_CLAIM_SUFFIX = '/identity/claims/role';

/**
 * JWT decode sonrası role claim'ini prefix'ten bağımsız okur.
 * Örn. http://schemas.microsoft.com/ws/2008/06/identity/claims/role
 */
export const getTokenRoles = (decoded: Record<string, unknown> | null | undefined): string[] => {
  if (!decoded || typeof decoded !== 'object') return [];

  const roleKey = Object.keys(decoded).find((key) => key.includes(ROLE_CLAIM_SUFFIX));
  if (!roleKey) return [];

  const roles = decoded[roleKey];
  if (typeof roles === 'string') return [roles];
  if (Array.isArray(roles)) return roles.map(String);
  return [];
};
